export const REPORT_PAGES_ROUTES = {
    SBOM_ROUTE: "sbom",
    SAASBOM_ROUTE: "saasbom",
    MLBOM_ROUTE: "mlbom",
    CBOM_ROUTE: "cbom",
    ISSUES_ROUTE: "issues",
    MALWARE_ROUTE: "malware",
    VULNERABILITIES_ROUTE: "vulnerabilities",
    SECRETS_ROUTE: "secrets",
    SIGNATURES_ROUTE: "signatures",
    BEHAVIOR_ROUTE: "behavior",
    NETWORKING_ROUTE: "networking",
    ISSUES_DIFF: "issues-diff",
    FILES_DIFF: "files-diff",
    VERSION_DIFF: "version-diff",
    VERSION_DIFF_THREAT_HUNTING: "threat-hunting",
    VERSION_DIFF_ISSUE_CHANGES: "issue-changes",
    VERSION_DIFF_FILE_CHANGES: "file-changes",
    REPRODUCIBILITY_ROUTE: "reproducibility",
    REPRODUCIBILITY_ISSUES: "issues",
    REPRODUCIBILITY_CHANGES: "changes",
    REPRODUCIBILITY_MODIFIED_FILES: "modified-files",
    FILE_BROWSER_ROUTE: "components",
    POLICIES_ROUTE: "policies",
    LICENSES_ROUTE: "licenses",
    STATISTICS_ROUTE: "statistics",
};
export const FILE_BROWSER_ROUTES = {
    INFO_ROUTE: "info",
    DEPENDENCIES_ROUTE: "dependencies",
    EVENTS_ROUTE: "events",
    ISSUES_ROUTE: "issues",
    VULNERABILITIES_ROUTE: "vulnerabilities",
    SECRETS_ROUTE: "secrets",
    BEHAVIOR_ROUTE: "behavior",
    SIGNATURES_ROUTE: "signatures",
    NETWORKING_ROUTE: "networking",
};
export const REPORT_QUERY_PARAMS = {
    build: "build",
    diff_with: "diff_with",
    path: "path",
    risk_category: "risk_category",
    risk_violations: "risk_violations",
};
//# sourceMappingURL=routeConstants.js.map